const resource = 'products'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },
  get(id, params) {
    return $axios.$get(`/${resource}/${id}`, { params })
  },
  getSuggestions(id, params) {
    return $axios.$get(`/${resource}/suggestions/${id}`, { params })
  },
  getAdminStats(productId) {
    return $axios.$get(`/${resource}/${productId}/admin-stats`)
  },
  fetchHomeSuggestions() {
    return $axios.$get('/v2/home-suggestions')
  },
  fetchCategoryPageProducts(categoryRef, params) {
    return $axios.$get(`/v2/category-page/${categoryRef}/products`, { params })
  },
  fetchCategoryPageFilters(categoryRef, params) {
    return $axios.$get(`/v2/category-page/${categoryRef}/filters`, { params })
  },
  fetchCategoryPageBestSales(categoryRef) {
    return $axios.$get(`/v2/category-page/${categoryRef}/best-sales-products`)
  },
  fetchCategoryPageNewest(categoryRef) {
    return $axios.$get(`/v2/category-page/${categoryRef}/newest-products`)
  },
  fetchCategoryPageBestRated(categoryRef) {
    return $axios.$get(`/v2/category-page/${categoryRef}/best-rated-products`)
  },
  fetchCategoryPageDiscounts(categoryRef) {
    return $axios.$get(`/v2/category-page/${categoryRef}/discounts-products`)
  },
  fetchProductsNewest() {
    return $axios.$get('/v2/products/newest')
  },
  fetchProductsNewestAnonymouslyIn(language) {
    return $axios.$get('/v2/products/newest', {
      headers: { 'X-Lang': language },
      transformRequest: [
        (data, headers) => {
          delete headers.Authorization
          if (headers.common) {
            delete headers.common.Authorization
          }
          return data
        },
      ],
    })
  },
  fetchProductsBestSales() {
    return $axios.$get('/v2/products/best-sales')
  },
  fetchProductsBestRated() {
    return $axios.$get('/v2/products/best-rated')
  },
  fetchProductsDiscounts() {
    return $axios.$get('/v2/products/discounts')
  },
  fetchBestBulbsProducts(vehicleId, params) {
    return $axios.$get(`/v2/best-bulbs/${vehicleId}/products`, { params })
  },
  fetchConfiguratorGroupProducts(groupIdentifier) {
    return $axios.$get(`/v2/configurator/group-products/${groupIdentifier}`)
  },
  fetchConfiguratorVehicleHeadlightTypeProducts(
    vehicleId,
    headlightTypeId,
    params
  ) {
    return $axios.$get(
      `/v2/configurator/vehicles/${vehicleId}/headlight-types/${headlightTypeId}/products`,
      { params }
    )
  },
  fetchConfiguratorVehicleHeadlightDetails(vehicleId, headlightTypeId) {
    return $axios.$get(
      `/v2/configurator/vehicles/${vehicleId}/headlight-types/${headlightTypeId}/details`
    )
  },
  fetchProductDetail(productRef, params) {
    return $axios.$get(`/v2/product/${productRef}`, { params })
  },
  fetchProductDetailReviews(productRef) {
    return $axios.$get(`/v2/product/${productRef}/reviews`)
  },
  fetchProductDetailAssociatedProducts(productRef) {
    return $axios.$get(`/v2/product/${productRef}/associated-products`)
  },
  fetchProductDetailMotorcycleBase(productRef) {
    return $axios.$get(`/v2/product/${productRef}/motorcycle-base-product`)
  },
  fetchProductDetailCompatibleVariants(productRef, params) {
    return $axios.$get(`/v2/product/${productRef}/compatible-variants`, {
      params,
    })
  },
  fetchProductDetailRelatedArticles(productRef) {
    return $axios.$get(`/v2/product/${productRef}/related-articles`)
  },
  fetchProductModalReviewProduct(productId) {
    return $axios.$get(`/v2/product-modal/review-product/${productId}`)
  },
  fetchProductModalAddToCartSuggestions(productId, params) {
    return $axios.$get(
      `/v2/product-modal/${productId}/add-to-cart-suggestions`,
      { params }
    )
  },
  fetchCartSuggestions() {
    return $axios.$get('/v2/cart/suggestions')
  },
  fetchCartShippingCutoff(shippingMethod = null) {
    return $axios.$get('/v2/cart/shipping-cutoff', {
      params: shippingMethod ? { shipping_method: shippingMethod } : {},
    })
  },
  fetchErrorPageRecommendedProducts(params) {
    return $axios.$get('/v2/error-page/recommended-products', { params })
  },
  fetchSiteSearchProducts(params) {
    return $axios.$get('/v2/site-search/products', { params })
  },
  fetchSiteSearchFilters(params) {
    return $axios.$get('/v2/site-search/filters', { params })
  },
  getRecentlyVisited(params) {
    return $axios.$get('/v2/products/recently-visited', { params })
  },

  getServiceName: name => 'productService',
})
